const MuiToggleButton: any = {
  styleOverrides: {
    root: {
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 3,
      paddingBottom: 3,
      "&.Mui-selected": {
        backgroundColor: "#0087C6",
        color: "#FFF",
      },
    },
  },
};

export default MuiToggleButton;
